<div class="offcanvas-container">

<div class="offcanvas-body">
  <div class="offcanvas-header px-0">
    <h4 class="offcanvas-title">
      Add Document or Link
    </h4>
    <button type="button" class="btn-close" (click)="onCancel()"></button>
  </div>
  <form #form="ngForm">
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <label class="form-label">Item Type</label>
        </div>
        <div class="col-1 required">
          <div class="danger">*</div>
        </div>
      </div>
      <select
        class="form-select"
        [ngModel]="itemType"
        (ngModelChange)="itemType = $event"
        name="itemType"
        required
      >
        <option value="" disabled selected>Select</option>
        <option value="Document">Document</option>
        <option value="Link">Link</option>
      </select>
      <div
        class="required invalid-feedback d-flex justify-content-start"
        *ngIf="form.submitted && !itemType"
      >
        <div class="danger">*</div>
        <span>Please select an item type.</span>
      </div>
    </div>

    <!-- Document fields -->
    <ng-container *ngIf="itemType === 'Document'">
      <!-- Name Field -->
      <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="docName">Name</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input
              type="text"
              id="docName"
              class="form-control"
              placeholder="Enter document name"
              name="docName"
              [ngModel]="name"
              (ngModelChange)="name = $event"
              #docName="ngModel"
              required
              [ngClass]="{
                'is-invalid':
                  docName.invalid && (docName.touched || form.submitted)
              }"
            />
          </div>
          <div
            class="col-12 required invalid-feedback d-flex justify-content-start"
          >
            <div
              *ngIf="docName.invalid && (docName.touched || form.submitted)"
              class="danger"
            >
              Invalid Entry – Please enter a document name.
            </div>
          </div>
        </div>
      </div>

      <!-- File Field -->
      <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="fileInput">File</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input
              type="file"
              id="fileInput"
              class="form-control"
              (change)="onFileSelected($event)"
              name="file"
              required
              #fileInput="ngModel"
              ngModel
            />
          </div>
          <div
            class="col-12 required invalid-feedback d-flex justify-content-start"
          >
            <div
              *ngIf="fileInput.invalid && (fileInput.touched || form.submitted)"
              class="danger"
            >
              Please select a file.
            </div>
          </div>
        </div>
      </div>

      <!-- Type Field -->
      <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="docType">Type</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <select
              id="docType"
              class="form-select"
              [ngModel]="docType"
              (ngModelChange)="docType = $event"
              name="docType"
              required
              #docTypeField="ngModel"
              [ngClass]="{
                'is-invalid':
                  docTypeField.invalid &&
                  (docTypeField.touched || form.submitted)
              }"
            >
              <option value="" disabled selected>Select</option>
              <option>Adoption</option>
              <option>General</option>
            </select>
          </div>
          <div
            class="col-12 required invalid-feedback d-flex justify-content-start"
          >
            <div
              *ngIf="
                docTypeField.invalid && (docTypeField.touched || form.submitted)
              "
              class="danger"
            >
              Please select a type.
            </div>
          </div>
        </div>
      </div>

      <!-- Species Field -->
      <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="species">Species</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <select
              id="species"
              class="form-select"
              [ngModel]="species"
              (ngModelChange)="species = $event"
              name="species"
              required
              #speciesField="ngModel"
              [ngClass]="{
                'is-invalid':
                  speciesField.invalid &&
                  (speciesField.touched || form.submitted)
              }"
            >
              <option value="" disabled>Select</option>
              <option value="All">All</option>
              <option value="Dog">Dog</option>
              <option value="Cat">Cat</option>
            </select>
          </div>
          <div
            class="col-12 required invalid-feedback d-flex justify-content-start"
          >
            <div
              *ngIf="
                speciesField.invalid && (speciesField.touched || form.submitted)
              "
              class="danger"
            >
              Please select a species.
            </div>
          </div>
        </div>
      </div>

      <!-- Life Stage Field -->
      <!-- <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="lifeStage">Life Stage</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <select
              id="lifeStage"
              class="form-select"
              [(ngModel)]="lifeStage"
              name="lifeStage"
              required
              size="5"
              #lifeStageField="ngModel"
              [multiple]="species !== 'All'"
              (change)="onLifeStageChange()"
              [ngClass]="{
                'is-invalid': lifeStageField.invalid && (lifeStageField.touched || form.submitted)
              }"
            >
              <ng-container *ngIf="species === 'All'">
                <option value="All">All</option>
              </ng-container>
              <ng-container *ngIf="species === 'Cat'">
                <option *ngFor="let option of catLifeStages" [value]="option.value">
                  {{ option.label }}
                </option>
              </ng-container>
              <ng-container *ngIf="species === 'Dog'">
                <option *ngFor="let option of dogLifeStages" [value]="option.value">
                  {{ option.label }}
                </option>
              </ng-container>
            </select>
          </div>
          <div class="col-12 required invalid-feedback d-flex justify-content-start">
            <div *ngIf="lifeStageField.invalid && (lifeStageField.touched || form.submitted)" class="danger">
              Please select a life stage.
            </div>
          </div>
        </div>
      </div> -->

  </ng-container>

    <!-- Link fields -->
    <ng-container *ngIf="itemType === 'Link'">
      <!-- Name Field -->
      <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="linkName">Name</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input
              type="text"
              id="linkName"
              class="form-control"
              placeholder="Enter link name"
              name="linkName"
              [ngModel]="linkName"
              (ngModelChange)="linkName = $event"
              #linkNameField="ngModel"
              required
              [ngClass]="{
                'is-invalid':
                  linkNameField.invalid &&
                  (linkNameField.touched || form.submitted)
              }"
            />
          </div>
          <div
            class="col-12 required invalid-feedback d-flex justify-content-start"
          >
            <div
              *ngIf="
                linkNameField.invalid &&
                (linkNameField.touched || form.submitted)
              "
              class="danger"
            >
              Please enter a link name.
            </div>
          </div>
        </div>
      </div>

      <!-- Link URL Field -->
      <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="linkUrl">Link URL</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input
              type="text"
              id="linkUrl"
              class="form-control"
              placeholder="Enter URL"
              name="linkUrl"
              [ngModel]="linkUrl"
              (ngModelChange)="linkUrl = $event"
              #linkUrlField="ngModel"
              required
              [ngClass]="{
                'is-invalid':
                  linkUrlField.invalid &&
                  (linkUrlField.touched || form.submitted)
              }"
            />
          </div>
          <div
            class="col-12 required invalid-feedback d-flex justify-content-start"
          >
            <div
              *ngIf="
                linkUrlField.invalid && (linkUrlField.touched || form.submitted)
              "
              class="danger"
            >
              Please enter a link URL.
            </div>
          </div>
        </div>
      </div>

      <!-- Type Field -->
      <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="linkDocType">Type</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <select
              id="linkDocType"
              class="form-select"
              [ngModel]="linkDocType"
              (ngModelChange)="linkDocType = $event"
              name="linkDocType"
              required
              #linkDocTypeField="ngModel"
              [ngClass]="{
                'is-invalid':
                  linkDocTypeField.invalid &&
                  (linkDocTypeField.touched || form.submitted)
              }"
            >
              <option value="" disabled selected>Select</option>
              <option>Adoption</option>
              <option>General</option>
            </select>
          </div>
          <div
            class="col-12 required invalid-feedback d-flex justify-content-start"
          >
            <div
              *ngIf="
                linkDocTypeField.invalid &&
                (linkDocTypeField.touched || form.submitted)
              "
              class="danger"
            >
              Please select a type.
            </div>
          </div>
        </div>
      </div>

      <!-- Species Field -->
      <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="linkSpecies">Species</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <select
              id="linkSpecies"
              class="form-select"
              [ngModel]="linkSpecies"
              (ngModelChange)="linkSpecies = $event"
              name="linkSpecies"
              required
              #linkSpeciesField="ngModel"
              [ngClass]="{
                'is-invalid':
                  linkSpeciesField.invalid &&
                  (linkSpeciesField.touched || form.submitted)
              }"
            >
              <option value="" disabled>Select</option>
              <option value="All">All</option>
              <option value="Dog">Dog</option>
              <option value="Cat">Cat</option>
            </select>
          </div>
          <div
            class="col-12 required invalid-feedback d-flex justify-content-start"
          >
            <div
              *ngIf="
                linkSpeciesField.invalid &&
                (linkSpeciesField.touched || form.submitted)
              "
              class="danger"
            >
              Please select a species.
            </div>
          </div>
        </div>
      </div>

      <!-- Life Stage Field -->
      <!-- <div class="mb-3 form-group">
        <div class="row">
          <div class="col-11">
            <label class="form-label" for="linkLifeStage">Life Stage</label>
          </div>
          <div class="col-1 required">
            <div class="danger">*</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <select
              id="linkLifeStage"
              class="form-select"
              [(ngModel)]="linkLifeStage"
              name="linkLifeStage"
              required
              size="5"
              #linkLifeStageField="ngModel"
              [multiple]="linkSpecies !== 'All'"
              (change)="onLinkLifeStageChange()"
              [ngClass]="{
                'is-invalid': linkLifeStageField.invalid && (linkLifeStageField.touched || form.submitted)
              }"
            >
              <ng-container *ngIf="linkSpecies === 'All'">
                <option value="All">All</option>
              </ng-container>
              <ng-container *ngIf="linkSpecies === 'Cat'">
                <option *ngFor="let option of catLifeStages" [value]="option.value">
                  {{ option.label }}
                </option>
              </ng-container>
              <ng-container *ngIf="linkSpecies === 'Dog'">
                <option *ngFor="let option of dogLifeStages" [value]="option.value">
                  {{ option.label }}
                </option>
              </ng-container>
            </select>
          </div>
          <div class="col-12 required invalid-feedback d-flex justify-content-start">
            <div *ngIf="linkLifeStageField.invalid && (linkLifeStageField.touched || form.submitted)" class="danger">
              Please select a life stage.
            </div>
          </div>
        </div>
      </div> -->

   </ng-container>
  </form>
</div>

<div
  *ngIf="itemType === 'Document' || itemType === 'Link'"
  class="offcanvas-footer p-3 d-flex justify-content-end"
    >
  <button type="button" class="secondaryBtn me-1" (click)="onCancel()">
    Cancel
  </button>
  <button type="button" class="primaryBtn" (click)="onSubmit(form)">Add</button>
</div>
</div>
